module.exports = __webpack_public_path__ + "img/historial.7e66f7cf.svg";